import { RETURN_TO_PARAM, parseReturnPath } from '@traceio-org/platform-contracts';

/**
 * Query parameter that carries the deep link a person asked for before sign-in. It is the contract's, so
 * destinations that link here (hubUrl) and this page read the same name.
 */
export { RETURN_TO_PARAM };

/**
 * Reads returnTo from a query string and keeps it only when parseReturnPath accepts it (a same-origin
 * relative path that cannot become an open redirect). Anything else is dropped silently and the
 * product's registered default path applies.
 */
export function readReturnTo(search: string): string | undefined {
  const raw = new URLSearchParams(search).get(RETURN_TO_PARAM);
  if (raw === null || raw === '') return undefined;
  const result = parseReturnPath(raw);
  return result.ok ? result.path : undefined;
}

/** Re-validates a return path that came from history state, app state or a server response. */
export function validReturnPath(value: unknown): string | undefined {
  if (value === undefined || value === null || value === '') return undefined;
  const result = parseReturnPath(value);
  return result.ok ? result.path : undefined;
}
